// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2eaa25f6] .el-select {\n  border-left: 1px solid #d8dce5;\n  border-right: 1px solid #d8dce5;\n  border-radius: 5px;\n}\n[data-v-2eaa25f6] .el-select input[type=\"text\"],[data-v-2eaa25f6] .el-select input[type=\"number\"] {\n    border-radius: 0;\n    border-left: none;\n    border-right: none;\n}\n", ""]);
// Exports
module.exports = exports;
